import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Posts from '../Posts';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';
import postsData from '../../assets/data/blog/posts.json';
import '../styles/pages.css';

const sortedPosts = [...postsData].sort((a, b) => new Date(b.date) - new Date(a.date));

export default function Blog() {
  const params = new URLSearchParams(useLocation().search);
  const activeSlug = params.get('post');
  const activePost = activeSlug ? sortedPosts.find(p => p.slug === activeSlug) : null;

  if (activePost) {
    const articleSchema = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: activePost.title,
      description: activePost.excerpt,
      datePublished: activePost.date,
      author: { '@type': 'Organization', name: activePost.author },
      articleSection: activePost.category,
    };

    return (
      <>
        <SEO
          title={activePost.title}
          description={activePost.excerpt}
          path={`/blog?post=${activePost.slug}`}
          jsonLd={articleSchema}
        />
        <main className='blog blog-article'>
          <article className='post-card glass-dark' style={{ maxWidth: '760px', margin: '3rem auto', padding: '2.5rem' }}>
            <div className='post-header'>
              <span className='post-category'>{activePost.category}</span>
              <span className='post-date'>
                {new Date(activePost.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
              </span>
            </div>
            <h1 className='post-title'>{activePost.title}</h1>
            {activePost.content.map((paragraph, idx) => (
              <p key={idx} className='post-excerpt' style={{ marginBottom: '1rem' }}>{paragraph}</p>
            ))}
            {activePost.link && (
              <a href={activePost.link} target="_blank" rel="noopener noreferrer" className='post-link'>
                Read more →
              </a>
            )}
            <Link to='/blog' className='post-link'>← Back to all posts</Link>
          </article>
        </main>
        <Copyrights />
        <Footer />
      </>
    );
  }

  const listSchema = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'IURIX Blog',
    blogPost: sortedPosts.map(p => ({
      '@type': 'BlogPosting',
      headline: p.title,
      datePublished: p.date,
      url: `https://www.iurix.com/blog?post=${p.slug}`,
    })),
  };

  return (
    <>
      <SEO
        title='Blog'
        description='Insights on cloud computing, AI & machine learning, and cybersecurity best practices from the IURIX team.'
        path='/blog'
        jsonLd={listSchema}
      />
      <main className='blog'>
        <h1 className='sr-only'>IURIX Blog</h1>
        <Posts posts={sortedPosts} />
      </main>
      <Copyrights/>
      <Footer/>
    </>
  );
}
